export let appConfig: AppConfig;

export const initAppConfig = async () => {
  const response = await fetch(`/app-config.json?_cb=${new Date().getTime()}`);
  appConfig = await response.json();
  console.log(`${appConfig.application}: build ${appConfig.buildNumber}`);
};

export interface AppConfig {
  application: string;
  appName: string;
  buildNumber: string;
  env: string;
  apiRoot: string;
  b2cScopes: string[];
  msalConfig: {
    auth: {
      clientId: string;
      authority: string;
      knownAuthorities: string[];
      redirectUri: string;
    };
    cache: {
      cacheLocation: string;
    };
  };
  sentry: {
    enabled: boolean;
    dsn: string;
    tracesSampleRate: number;
  };
}
